import React from 'react';

export interface AuthContext {
  authToken: null | string;
  setAuthToken: (token: string | null) => void;
  isLoggedIn?: boolean;
  logout: () => void;
  loading: boolean;
}

export const authContext = React.createContext<AuthContext>({
  authToken: null,
  setAuthToken: () => {},
  isLoggedIn: false,
  logout: () => {},
  loading: true,
});

interface StorageHandler {
  getItem(key: string): Promise<string | null> | string | null;
  setItem(key: string, value: string | null): Promise<void> | void;
  removeItem(key: string): Promise<void> | void;
}

interface AuthProviderProps {
  storageHandler: StorageHandler;
  children: React.ReactNode;
}
export const AuthProvider = (props: AuthProviderProps) => {
  const [authToken, setAuthToken] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const doAsync = async () => {
      try {
        const savedAuthToken = await props.storageHandler.getItem('userToken');
        savedAuthToken && setAuthToken(savedAuthToken);
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    };
    doAsync();
  }, []);

  const persistAuthToken = React.useCallback(async (token: string | null) => {
    await props.storageHandler.setItem('userToken', token);
    setAuthToken(token);
  }, []);

  const logout = React.useCallback(async () => {
    await props.storageHandler.removeItem('userToken');
    setAuthToken(null);
  }, []);

  return (
    <authContext.Provider
      value={{
        authToken,
        setAuthToken: persistAuthToken,
        loading,
        logout,
      }}>
      {props.children}
    </authContext.Provider>
  );
};

export default authContext;
